import { ShiftOpportunityType } from '@amzn/atoz-shiftapp-types';
export function getDropOpportunity(scheduleShift, shiftOpportunities) {
    if (!shiftOpportunities.length) {
        return null;
    }
    for (var _i = 0, shiftOpportunities_1 = shiftOpportunities; _i < shiftOpportunities_1.length; _i++) {
        var shiftOpportunity = shiftOpportunities_1[_i];
        if (shiftOpportunity.type === ShiftOpportunityType.Drop &&
            shiftOpportunity.shift.id === scheduleShift.shift.id) {
            return shiftOpportunity;
        }
    }
    // none found
    return null;
}
